import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { FormattedMessage } from 'react-intl';
import { css, StyleSheet } from 'aphrodite';
import { AuditEntryShape, TSS_RED, TSS_GREEN } from 'tss-core-lib-common';
import Icon from 'react-svg-ikon';
import { IMG_ICON_LOCK } from '../../img';

var styles = void 0;

var AuditEntryDetails = function AuditEntryDetails(_ref) {
  var entry = _ref.entry,
      translationPrefix = _ref.translationPrefix,
      dateTimeFormat = _ref.dateTimeFormat;
  return React.createElement(
    'div',
    { className: css(styles.container) },
    entry.date ? React.createElement(
      'div',
      { className: css(styles.row) },
      React.createElement(
        'div',
        { className: css(styles.rowLabel) },
        React.createElement(FormattedMessage, { id: translationPrefix + '.date' })
      ),
      React.createElement(
        'div',
        { className: css(styles.rowValue) },
        moment.utc(entry.date).format(dateTimeFormat)
      )
    ) : null,
    entry.description ? React.createElement(
      'div',
      { className: css(styles.row) },
      React.createElement(
        'div',
        { className: css(styles.rowLabel) },
        React.createElement(FormattedMessage, { id: translationPrefix + '.description' })
      ),
      React.createElement(
        'div',
        { className: css(styles.rowValue) },
        entry.description
      )
    ) : null,
    entry.userName ? React.createElement(
      'div',
      { className: css(styles.row) },
      React.createElement(
        'div',
        { className: css(styles.rowLabel) },
        React.createElement(FormattedMessage, { id: translationPrefix + '.user' })
      ),
      React.createElement(
        'div',
        { className: css(styles.rowValue) },
        entry.userName,
        ' ( ',
        entry.userId,
        ' ',
        entry.loginUsername !== null && ', ' + entry.loginUsername,
        ')'
      )
    ) : null,
    entry.officeName ? React.createElement(
      'div',
      { className: css(styles.row) },
      React.createElement(
        'div',
        { className: css(styles.rowLabel) },
        React.createElement(FormattedMessage, { id: translationPrefix + '.office' })
      ),
      React.createElement(
        'div',
        { className: css(styles.rowValue) },
        entry.officeName
      )
    ) : null,
    entry.action ? React.createElement(
      'div',
      { className: css(styles.row) },
      React.createElement(
        'div',
        { className: css(styles.rowLabel) },
        React.createElement(FormattedMessage, { id: translationPrefix + '.action' })
      ),
      React.createElement(
        'div',
        { className: css(styles.rowValue) },
        entry.action
      )
    ) : null,
    entry.status ? React.createElement(
      'div',
      { className: css(styles.row) },
      React.createElement(
        'div',
        { className: css(styles.rowLabel) },
        React.createElement(FormattedMessage, { id: translationPrefix + '.status' })
      ),
      React.createElement(
        'div',
        { className: css(styles.rowValue) },
        entry.status
      )
    ) : null,
    entry.valueChanges && entry.valueChanges.size ? React.createElement(
      'div',
      { className: css(styles.row) },
      React.createElement(
        'div',
        { className: css(styles.rowLabel) },
        React.createElement(FormattedMessage, { id: translationPrefix + '.value.changes' })
      ),
      React.createElement(
        'div',
        { className: css(styles.rowValue) },
        React.createElement(
          'table',
          { className: css(styles.table) },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                { className: css(styles.header) },
                React.createElement(FormattedMessage, { id: translationPrefix + '.value.changes.field.name' })
              ),
              React.createElement(
                'th',
                { className: css(styles.header) },
                React.createElement(FormattedMessage, { id: translationPrefix + '.value.changes.before' })
              ),
              React.createElement(
                'th',
                { className: css(styles.header) },
                React.createElement(FormattedMessage, { id: translationPrefix + '.value.changes.after' })
              )
            )
          ),
          React.createElement(
            'tbody',
            null,
            entry.valueChanges.map(function (_ref2) {
              var fieldName = _ref2.fieldName,
                  valueAfter = _ref2.valueAfter,
                  valueBefore = _ref2.valueBefore;
              return React.createElement(
                'tr',
                { key: fieldName + valueAfter },
                React.createElement(
                  'td',
                  { className: css(styles.cell) },
                  fieldName
                ),
                React.createElement(
                  'td',
                  { className: css(styles.cell) },
                  valueBefore
                ),
                React.createElement(
                  'td',
                  { className: css(styles.cell) },
                  valueAfter
                )
              );
            })
          )
        )
      )
    ) : null,
    entry.signature ? React.createElement(
      'div',
      { className: css(styles.row) },
      React.createElement(
        'div',
        { className: css(styles.rowLabel) },
        React.createElement(FormattedMessage, { id: translationPrefix + '.signature' })
      ),
      React.createElement(
        'div',
        { className: css(styles.rowValue, styles.signatureOkValue, entry.signature.integrityOk && entry.signature.successful ? null : styles.signatureFailValue) },
        React.createElement(
          'div',
          { className: css(styles.lock) },
          React.createElement(Icon, { src: IMG_ICON_LOCK, color: entry.signature.integrityOk && entry.signature.successful ? TSS_GREEN() : TSS_RED(), className: css(styles.lockIcon) })
        ),
        React.createElement('div', { className: css(styles.row, styles.firstRowInRow) }),
        !entry.signature.integrityOk ? React.createElement(
          'div',
          { className: css(styles.row) },
          React.createElement(
            'div',
            { className: css(styles.rowLabel) },
            React.createElement(FormattedMessage, { id: translationPrefix + '.signature.integrity.failed' })
          )
        ) : React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: css(styles.row) },
            React.createElement(
              'div',
              { className: css(styles.rowLabel) },
              React.createElement(FormattedMessage, { id: translationPrefix + '.signature.timestamp' })
            ),
            React.createElement(
              'div',
              { className: css(styles.rowValue) },
              moment.utc(entry.signature.timestamp).format(dateTimeFormat)
            )
          ),
          React.createElement(
            'div',
            { className: css(styles.row) },
            React.createElement(
              'div',
              { className: css(styles.rowLabel) },
              React.createElement(FormattedMessage, { id: translationPrefix + '.signature.description' })
            ),
            React.createElement(
              'div',
              { className: css(styles.rowValue) },
              entry.signature.description
            )
          ),
          React.createElement(
            'div',
            { className: css(styles.row) },
            React.createElement(
              'div',
              { className: css(styles.rowLabel) },
              React.createElement(FormattedMessage, { id: translationPrefix + '.signature.signer' })
            ),
            React.createElement(
              'div',
              { className: css(styles.rowValue) },
              entry.signature.signerFullname,
              ' ( ',
              entry.signature.signerUserId,
              entry.loginUsername !== null && ', ' + entry.loginUsername,
              ' ) '
            )
          ),
          React.createElement(
            'div',
            { className: css(styles.row) },
            React.createElement(
              'div',
              { className: css(styles.rowLabel) },
              React.createElement(FormattedMessage, { id: translationPrefix + '.signature.comment' })
            ),
            React.createElement(
              'div',
              { className: css(styles.rowValue) },
              entry.signature.comment
            )
          ),
          React.createElement(
            'div',
            { className: css(styles.row) },
            React.createElement(
              'div',
              { className: css(styles.rowLabel) },
              React.createElement(FormattedMessage, { id: translationPrefix + '.signature.successful' })
            ),
            React.createElement(
              'div',
              { className: css(styles.rowValue) },
              React.createElement(FormattedMessage, { id: entry.signature.successful ? 'label.yes' : 'label.no' })
            )
          )
        )
      )
    ) : null
  );
};

AuditEntryDetails.propTypes = {
  entry: AuditEntryShape.isRequired,
  translationPrefix: PropTypes.string,
  dateTimeFormat: PropTypes.string.isRequired
};

AuditEntryDetails.defaultProps = {
  translationPrefix: 'module.components.audit.details'
};

styles = StyleSheet.create({
  container: {
    fontSize: '1.2rem'
  },

  row: {
    display: 'flex',
    margin: '0.9rem 0'
  },

  firstRowInRow: {
    marginTop: 0
  },

  rowLabel: {
    width: '13rem',
    fontWeight: 600
  },

  rowValue: {
    flex: '1 0 0%',
    maxWidth: '60rem'
  },

  signatureOkValue: {
    position: 'relative',
    padding: '1.6rem',
    left: '-1.6rem',
    border: '1px solid #ccc',
    borderRadius: 4,
    backgroundColor: TSS_GREEN(0.05)
  },

  signatureFailValue: {
    backgroundColor: TSS_RED(0.05)
  },

  lock: {
    position: 'absolute',
    top: 0,
    left: 0,
    marginLeft: '-1.2rem',
    marginTop: '-1.2rem',
    border: '1px solid #ccc',
    borderRadius: '50%',
    backgroundColor: 'white',
    width: '3rem',
    height: '3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  lockIcon: {
    position: 'relative',
    top: -2
  },

  table: {
    emptyCells: 'show',
    borderSpacing: 0,
    borderCollapse: 'collapse',
    margin: 0
  },

  header: {
    borderBottom: '1px solid #ccc',
    padding: '0 1.6rem 0.8rem 1.6rem',
    textAlign: 'left',
    fontSize: '1.2rem',

    ':first-child': {
      paddingLeft: 0
    }
  },

  cell: {
    padding: '0.8rem 1.6rem',
    textAlign: 'left',
    fontSize: '1.2rem',

    ':first-child': {
      paddingLeft: 0
    }
  }
});

export default AuditEntryDetails;